class PDFViewer {
	constructor($sce, $http, $timeout, $window, $rootScope) {
		this.restrict = 'E';
		this.scope = {
			url: '=',
			isLoading: '='
		};
		this.template = this.template();

		this.$sce = $sce;
		this.$http = $http;
		this.$window = $window;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;

		this.$iFrame = null;
		this.$element = null;
	}

	init(element) {
		this.$element = $(element);
	}

	template() {
		return `
			${this.pageStyles}
			${this.busyIndicator}
			<iframe id='pdfViewer' runat="server">
			</iframe>
			<div class="isLoading">
			</div>
        `;
	}

	link(scope, element, attrs) {
		this.init(element);
		this.ngScope = scope;

		scope.$watch('url', (newVal) => {
			if (newVal) {
				const styles = [{ name: 'display', value: 'none' }];
				const $content = $('*', this.$element);
				this._applyStyling($content, styles);

				this.switchIsBusy(true);
				this.clearOutIFrame();

				newVal = this.$sce.valueOf(newVal);

				const dots = newVal.split('.');
				let fileExtension = dots[dots.length - 1];
				let isPdf = newVal.indexOf('?extension=pdf') !== -1;

				if (isPdf || newVal.toLowerCase().indexOf('/byid/') > -1) {
					fileExtension = 'pdf';
					newVal = newVal.replace('?extension=pdf', '');
				}

				switch (fileExtension.toLowerCase()) {
					case 'pdf':
					case 'html':
					case 'htm':
					case 'jpg':
					case 'jpeg':
					case 'png':
					case 'bmp':
					case 'tif':
					case 'tiff':
						this.renderIFrame(newVal);
						break;
					default:
						const downloadIndicator = `${pretorOnlineUrl
							? pretorOnlineUrl + 'home/downloading'
							: 'http://localhost:58626/home/downloading'}`;

						try {
							const data = $.ajax({
								url: newVal,
								method: 'GET',
								xhrFields: {
									responseType: 'blob'
								},
								success: (data, textStatus, xhr) => {
									const a = document.createElement('a');
									const urlData = window.URL.createObjectURL(data);
									a.href = urlData;
									a.download = `Download.${fileExtension.toLowerCase()}`;
									a.click();
									window.URL.revokeObjectURL(urlData);
								},
								error: (err) => {
									this.renderIFrame(downloadIndicator);
								}
							});
						} catch (err) {
							this.renderIFrame(downloadIndicator);
						}

						this.renderIFrame(downloadIndicator);
						break;
				}
			}
		});
	}

	/**
	 * Gets the Loading indicator content
	 * @readonly
	 * @returns {String} Loading indicator content
	 * @memberOf PDFViewer
	 */
	get busyIndicator() {
		const src =
			(_.endsWith(PretorCDNAddress, '/') ? PretorCDNAddress : PretorCDNAddress + '/') + 'images/loading doc.gif';
		return `
		  <div class="loading">
			<img src="${src}" alt="Pretor Loading indicator" />
	  	  </div>
		`;
	}

	/**
	 * Gets the PDF Viewer's styles
	 * @readonly
	 * @returns {String} The PDF Viewer's styles
	 * @memberOf PDFViewer
	 */
	get pageStyles() {
		return `
			<style>	
				.pdf-viewer-container>pdf-viewer>iframe,
				.pdf-viewer-container>pdf-viewer>.loading {
					width: 100% !important;
					height: 100%;
					display: none;
				
					min-height: 30em;
				}

				.pdf-viewer-container>pdf-viewer>.loading>img {
					max-width: 40em;
					max-height: 12em;
					margin: 5% auto 0 auto;
				}

				.pdf-viewer-div.modal .modal-dialog .modal-content {
					//min-width: 65em;
					width: 100%;
				}
			</style>
		`;
	}

	/**
	 * Sets the document's URL for displaying
	 * @param {String} url the document URL
	 * @memberOf PDFViewer
	 */
	async renderIFrame(url) {
		const errorUrl = `${pretorOnlineUrl
			? pretorOnlineUrl + 'home/notFound'
			: 'http://localhost:58626/home/NotFound'}`;

		try {
			if (url.toLowerCase() !== errorUrl.toLowerCase()) {
				await this.$http.get(url);
				this.setIFrameSrc(url);
			} else {
				this.setIFrameSrc(errorUrl);
			}
		} catch (error) {
			const msg = `Error while rendering document`;
			console.error(`${msg}: \n${JSON.stringify(error)}`);
			this.setIFrameSrc(errorUrl);
		}
	}

	clearOutIFrame() {
		/*
		const $iFrame = $('iframe#pdfViewer', this.$element);
		$iFrame.empty();
		*/
	}

	/**
	 * Sets the document's src and displays the iframe
	 * @param {String} url The URL of the document
	 * @memberOf PDFViewer
	 */
	setIFrameSrc(url) {
		const $context = this.$element.closest('.modal.fade.in')[0];
		const $iFrame = $('iframe#pdfViewer', $context);

		$iFrame.on('load', () => {
			this.switchIsBusy(false);
			this._applyStyling($iFrame, [{ name: 'display', value: 'block' }]);
			this.$timeout(() => {
				if (this.ngScope.url) {
					this.$timeout(() => {
						this.ngScope.url = this.$sce.trustAsResourceUrl('');
					}, 1500);
				}
			}, 400);
		});

		$iFrame.attr('src', url);
		this._applyStyling($iFrame, [{ name: 'display', value: 'none' }]);
	}

	/**
	 * Shows and hides the loading indicator
	 * @param {Boolean} shouldShow Should show flag
	 * @memberOf PDFViewer
	 */
	switchIsBusy(shouldShow) {
		const $isLoadingDiv = $('.loading, .loading *', this.$element);

		const styles = [
			{
				name: 'display',
				value: shouldShow ? 'flex' : 'none'
			}
		];

		this._applyStyling($isLoadingDiv, styles);
	}

	/**
	 * Method for safely applying styles
	 *  
	 * @param {JQuery<HTMLElement>} elements Elements to apply styling to
	 * @param {Object[]} styles Styles to be applied
	 * @memberOf PDFViewer
	 */
	_applyStyling(elements, styles) {
		elements.each((i, element) => {
			styles.forEach((style) => {
				element.style.removeProperty(style.name);
				element.style.setProperty(style.name, style.value, 'important');
			});
		});
	}
}

export default /* @ngInject */ ($sce, $http, $timeout, $window, $rootScope) =>
	new PDFViewer($sce, $http, $timeout, $window, $rootScope);
